import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { MetaMultiselectComponent } from './meta-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        MetaMultiselectComponent
    ],
    exports: [
        MetaMultiselectComponent
    ]
})
export class MetaMultiselectModule { }
